"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketProviders = void 0;
const providers_1 = require("@ethersproject/providers");
const sdk_1 = require("@yfi/sdk");
const coincap_1 = require("./coincap/coincap");
const coingecko_1 = require("./coingecko/coingecko");
const foxy_1 = require("./foxy/foxy");
const osmosis_1 = require("./osmosis/osmosis");
const yearn_tokens_1 = require("./yearn/yearn-tokens");
const yearn_vaults_1 = require("./yearn/yearn-vaults");
// YearnVaultMarketCapService deps
const network = 1; // 1 for mainnet
const provider = new providers_1.JsonRpcProvider(process.env.REACT_APP_ETHEREUM_NODE_URL);
const yearnSdk = new sdk_1.Yearn(network, { provider });
// Order of this MarketProviders array constitutes the order of provders we will be checking first.
// More reliable providers should be listed first.
exports.MarketProviders = [
    new coingecko_1.CoinGeckoMarketService(),
    new coincap_1.CoinCapMarketService(),
    new yearn_vaults_1.YearnVaultMarketCapService({ yearnSdk }),
    new yearn_tokens_1.YearnTokenMarketCapService({ yearnSdk }),
    new osmosis_1.OsmosisMarketService(),
    new foxy_1.FoxyMarketService()
];
